import React, { useContext } from "react";

export const context = React.createContext<AppState>({} as any);

export function useAppContext(): AppState {
  return useContext(context);
}
